import React, { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { buildDocumentPreviewRows } from '@/features/ui/DocumentsData/model/preview';

import { IntegrationSystem } from '@/shared/types';
import { ConditionView, Grid, Loader, StepControlPanel } from '@/shared/ui';

import { useAsyncDataLoader } from '@/hooks/useAsyncDataLoader';

import { getERZDocumentsSelect } from '@/modules/erz/helpers';

import { DocumentTypeCode, DocumentTypeEntity } from '@/api/types';

import { DocumentsData } from '../../DocumentsData';

import { HealthDataSchema } from './model/types';

export const HealthData: React.FC<StepProps> = ({ currentRequestId, prev, next, onStepDraftSave }) => {
  const fetchDocumentTypes = useCallback(
    () =>
      getERZDocumentsSelect({
        allowedDocumentTypeCodes: [DocumentTypeCode.MEDICAL_REFERENCE],
      }),
    [],
  );

  const {
    data: documentTypeEntities = [],
    isLoading: isHealthDataLoading,
    load: loadDocumentTypeEntities,
  } = useAsyncDataLoader<Array<DocumentTypeEntity<IntegrationSystem.ERZ>>>(fetchDocumentTypes, {
    defaultDataValue: [],
  });

  const safeRequestId = currentRequestId ?? '';

  useEffect(() => {
    loadDocumentTypeEntities();
  }, []);

  return (
    <ConditionView if={!isHealthDataLoading} else={<Loader />}>
      <FormBlock title="Дані про стан здоров’я">
        <DocumentsData
          withUploader
          documentTypeSelectDisabled
          documentTypeEntities={documentTypeEntities ?? []}
          maxDocumentsCount={1}
          name="healthDataDocument"
          request_id={safeRequestId}
          onSaveDraft={onStepDraftSave}
          documentsRequired
        />
      </FormBlock>
      <StepControlPanel prev={prev} next={next} />
    </ConditionView>
  );
};

export const HealthDataPreview: React.FC = () => {
  const { getValues } = useFormContext<HealthDataSchema>();
  const { healthDataDocument } = getValues();
  const doc = Array.isArray(healthDataDocument) ? healthDataDocument[0] : undefined;
  const rows = buildDocumentPreviewRows(doc, 'Документ, який підтверджує стан здоровʼя');

  return rows.length ? <Grid title="Дані про стан здоров’я" data={rows} /> : null;
};
